export default {
  title: {
    en: 'Shop the dads & grads gift guide',
  },
  button: {
    en: 'Shop now',
  },
}
